import AddPdfContainer from "./AddPdfContainer";

const AddPdf = AddPdfContainer;
export default AddPdf;
